import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import SearchPatientForm from './SearchPatientForm'

interface Props {
  isOpen: boolean
  title?: string
  onClose: () => void
}

const CreatePatientFromSearchDialog = ({ isOpen, onClose, title }: Props) => {
  const [isAddingPatient, setIsAddingPatient] = useState(false)
  const [isSearchingPatient,setIsSearchingPatient] = useState(false)

  const handleClose = () => {
    if (isAddingPatient || isSearchingPatient) {
      return
    }
    onClose()
  }
  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="xl"
      motionPreset="slideInBottom"
      isCentered
    >
      <ModalOverlay
        bg="blackAlpha.600"
        backdropFilter="blur(4px)"
      />
      <ModalContent
        borderRadius="8px"
        maxW="550px"
        boxShadow="xl"
      >
        <ModalHeader
          textAlign="center"
          fontWeight={600}
          fontSize="16px"
          color="#161616"
        >
          {title}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pt={0} px="16px" pb={4} className="custom-scroll">
          <SearchPatientForm 
          isAddingPatient={isAddingPatient}
          setIsAddingPatient={setIsAddingPatient}
          isSearchingPatient={isSearchingPatient}
          setIsSearchingPatient={setIsSearchingPatient}
          onClose={onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default CreatePatientFromSearchDialog